import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import NavItem from '../../../components/NavItem';
import IconButton from '../../../components/IconButton';
import api from '../../../services/api';
import DataTable from 'react-data-table-component';

export default function PainelPlanoConta() {
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState({});
    const [planoContas, setPlanoContas] = useState([]);

    const buscar = () => {
        setFiltro({ ...filtro, ...{ buscando: true } });
        api({
            method: 'get',
            action: '/financeiroPlanoConta',
            token: token,
            params: filtro
        })
            .then(response => {
                setPlanoContas(response.data.data);
                setFiltro({ ...filtro, ...{ buscando: false } });
            }).catch(err => {
                //console.log(err)
            })
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    <NavItem to="/cadastroPlanoConta" icon={<FaPlus size={20} />} color="primary">Nova Conta</NavItem>
                </ul>
                <div className="page-title">
                    <h3>Plano de Contas</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="nome" placeholder="Buscar pelo nome da conta"
                                                            onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Nome</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSearch size={20} /> Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row mb-4">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body px-0 pb-0">
                                    <div className="table-responsive">
                                        <DataTable
                                            progressPending={filtro.buscando ?? false}
                                            progressComponent={<div>Buscando...</div>}
                                            noDataComponent="Nenhum registro"
                                            paginationComponentOptions={{ rowsPerPageText: 'Linhas', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }}
                                            pagination="true"
                                            className="table mb-0"
                                            columns={[
                                                {
                                                    name: '',
                                                    selector: 'codigo',
                                                    cell: row => row.bancoDados ? <IconButton
                                                        small={true}
                                                        to={"/cadastroPlanoConta/" + row.id}
                                                        icon={<FaPen size={20} />}
                                                        color="primary">Alterar</IconButton> : null,
                                                    width: "120px",
                                                },
                                                {
                                                    name: 'Situação',
                                                    selector: row => row.situacaoRegistro ?? "",
                                                    sortable: true,
                                                    width: "95px",
                                                },
                                                {
                                                    name: 'Tipo',
                                                    selector: row => row.tipo ?? "",
                                                    sortable: true,
                                                    width: "100px",
                                                    cell: (row) => {
                                                        return row.tipo === 1 ? 'Analítica' : "Sintética";
                                                    },
                                                },
                                                {
                                                    name: 'Código',
                                                    selector: row => row.caminho ?? "",
                                                    sortable: true,
                                                    width: "100px",
                                                    right: false,
                                                },
                                                {
                                                    name: 'Nome',
                                                    selector: row => row.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        return row.tipo === 2 ?
                                                            <strong>{row.nome}</strong> :
                                                            row.nome;
                                                    },
                                                },
                                                {
                                                    name: 'Superior',
                                                    selector: row => row.superior?.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        return row.superior ? <strong>{row.superior.caminho + ' - ' + row.superior.nome}</strong> : "";
                                                    },
                                                },
                                                {
                                                    name: 'Grupo DRE',
                                                    selector: row => row.grupodre?.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        if (row.grupodre) {
                                                            var textoSoma = row.grupodre.operacao === 1 ? "(+)" : "(-)";
                                                            return textoSoma + ' ' + row.grupodre.nome;

                                                        } else {
                                                            return '';
                                                        }
                                                    },
                                                },
                                            ]}
                                            data={planoContas}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
